import { useMatchRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

import { useRegisterCommandBarEmptyMessage } from '../components/command-bar-empty-message.js';
import { useRegisterCommandBarPlaceholder } from '../hooks/use-register-command-bar-placeholder.js';
import { RegisterCadstromUidProvider } from './cadstrom-uid-provider/cadstrom-uid-provider.js';
import { RegisterCreateOrgProvider } from './create-org-provider.js';
import { RegisterCreatePackageFamilyProvider } from './create-package-family-provider.js';
import { DesignSearchEmptyMessage } from './design-search-provider/design-search-empty-message.js';
import { ModuleSearchEmptyMessage } from './module-search-provider/module-search-empty-message.js';
import { NetSearchEmptyMessage } from './net-search-provider/net-search-empty-message.js';
import { PackageSearchEmptyMessage } from './package-search-provider/package-search-empty-message.js';
import { RegisterPackageSearchProvider } from './package-search-provider/package-search-provider.js';
import { RegisterPageNavigationProvider } from './page-navigation-provider.js';

/**
 * Empty messages for search providers - registered at root so that we display a notice
 * if that particular search prefix isn't available on the current page
 */
export function CommandBarGlobals() {
	const matchRoute = useMatchRoute();

	// Placeholder text
	useRegisterCommandBarPlaceholder('Type a command or search...');

	// Empty messages
	useRegisterCommandBarEmptyMessage(useMemo(() => <DesignSearchEmptyMessage />, []));
	useRegisterCommandBarEmptyMessage(useMemo(() => <ModuleSearchEmptyMessage />, []));
	useRegisterCommandBarEmptyMessage(useMemo(() => <NetSearchEmptyMessage />, []));
	useRegisterCommandBarEmptyMessage(useMemo(() => <PackageSearchEmptyMessage />, []));

	if (matchRoute({ to: '/logged-out' }) !== false) {
		return null;
	}

	// Providers
	return (
		<>
			<RegisterCadstromUidProvider />
			<RegisterPageNavigationProvider />
			<RegisterPackageSearchProvider />
			<RegisterCreatePackageFamilyProvider />
			<RegisterCreateOrgProvider />
		</>
	);
}
